import storage from '@/services/storage.js'
import {
    createRouter,
    createWebHistory
} from 'vue-router'

import { useStore } from "vuex";

import Main from "@/views/Main.vue";
import Home from "@/views/Home.vue"
import Login from "@/views/Login.vue"
import ResetPassword from '@/views/login/ResetPassword.vue';
import AttivazioneAccount from '@/views/login/AttivazioneAccount.vue';

import Profilo from "@/views/Profilo.vue"

import ElencoOrdini from '@/views/ElencoOrdini.vue'
import DettaglioOrdine from '@/views/DettaglioOrdine.vue'

import GestioneUtenti from '@/views/amministrazione/GestioneUtenti.vue';
import GestioneParametri from '@/views/amministrazione/GestioneParametri.vue';

import Registrazione from '@/views/login/Registrazione.vue';
import GestioneAziende from '@/views/admin/GestioneAziende.vue';

const routes = [{
    path: "/",
    meta: {
        auth: true
    },
    component: Main,

    children: [{
        path: "/:catchAll(.*)",
        component: Home,
    },
    {
        path: "/",
        meta: {
            auth: true
        },
        component: Home,
    }, {
        path: '/ordini',
        name: 'ElencoOrdini',
        component: ElencoOrdini,
        meta: {
            title: 'Elenco Ordini'
        }
    },
    {
        path: '/ordini/:id',
        name: 'DettaglioOrdine',
        component: DettaglioOrdine,
        meta: {
            title: 'Dettaglio Ordine'
        }
    },
    {
        path: '/gestione-utenti',
        name: 'GestioneUtenti',
        component: GestioneUtenti,
        meta: {
            title: 'Gestione utenti'
        }
    },
    {
        path: '/gestione-parametri',
        name: 'GestioneParametri',
        component: GestioneParametri,
        meta: {
            title: 'Gestione parametri'
        }
    },
    // Route super admin - gestione aziende
    {
        path: '/admin/aziende',
        name: 'GestioneAziende',
        component: GestioneAziende,
        meta: { requiresAuth: true, requiresSuperAdmin: true }
    },
    {
        path: '/profilo/:tab?',
        name: 'profilo',
        component: Profilo,
        meta: {
            requiresAuth: true
        },
        beforeEnter: (to, from, next) => {
            const validTabs = ['utente', 'azienda', 'api', 'licenza']
            const tab = to.params.tab

            const store = useStore();
            // Ottieni il ruolo dallo store
            const role = store.getters['user/getRole']

            // Se la tab è API e il ruolo è 2, reindirizza
            if (tab === 'api' && (role === 1 || role === 3)) {
                next({ name: 'profilo', params: { tab: 'utente' }, replace: true })
                return
            }

            if (!tab) {
                next({ name: 'profilo', params: { tab: 'utente' }, replace: true })
            }
            else if (!validTabs.includes(tab)) {
                next({ name: 'profilo', params: { tab: 'utente' }, replace: true })
            }
            else {
                next()
            }
        }
    }
    ]
}, {
    path: "/login",
    name: "LoginPage",
    component: Login,
}, {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: { requiresAuth: false }
},
{
    path: '/attivazione',
    name: 'AttivazioneAccount',
    component: AttivazioneAccount,
    meta: { requiresAuth: false }
},
{
    path: '/registrazione',
    name: 'Registrazione',
    component: Registrazione,
    meta: { requiresAuth: false }
},
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach(async (to, from, next) => {
    const store = useStore();

    if (to.path === "/@esci") {
        storage.logout();
        return;
    }

    // ── Controllo autenticazione base ────────────────────────────────────────
    const isStorageAuth = storage.checkAuth();

    if (to.path !== "/login" && to.meta.auth && !isStorageAuth) {
        return next({ path: '/login' });
    }

    if (to.path === "/login" && isStorageAuth) {
        return next({ path: '/' });
    }

    // ── Se autenticato, assicurati che lo store sia popolato ─────────────────
    // Al refresh lo store è vuoto: aspetta il caricamento userInfo prima
    // di valutare licenzaStato, così non si vede mai PaginaDemo per errore.
    if (isStorageAuth) {
        const isStorePopulated = !!store.getters['user/getNome'];

        if (!isStorePopulated) {
            try {
                await store.dispatch('user/userInfo');
            } catch {
                // Token scaduto o errore: vai al login
                storage.logout();
                return next({ path: '/login' });
            }
        }

        // Ora lo store è sicuramente popolato, leggo il valore reale
        const licenzaStato = store.getters['user/getLicenzaStato'];

        const routeBloccate = ['DettaglioOrdine', 'GestioneUtenti', 'GestioneParametri'];
        if (licenzaStato !== 1 && routeBloccate.includes(to.name)) {
            return next({ name: 'PaginaDemo' });
        }
    }

    next();
});
export default router